import React from 'react';
import {useSelector} from "react-redux";
import {get} from "dot-prop-immutable";

import AdmissionList_Item_ManagerCustomUI_UploadPdf from "../AdmissionsList/Item/ManagerCustomUi/AdmissionList_Item_ManagerCustomUI_UploadPdf";
import AdmissionList_Item_ManagerCustomUI_PreAdmission from "../AdmissionsList/Item/ManagerCustomUi/AdmissionList_Item_ManagerCustomUI_PreAdmission";
import AdmissionList_Item_ManagerCustomUI_SendRegMed from "../AdmissionsList/Item/ManagerCustomUi/AdmissionList_Item_ManagerCustomUI_SendRegMed";
import AdmissionList_Item_ManagerCustomUI_Comments from "../AdmissionsList/Item/ManagerCustomUi/AdmissionList_Item_ManagerCustomUI_Comments";
import AdmissionList_Item_ManagerCustomUI_Send2 from "../AdmissionsList/Item/ManagerCustomUi/AdmissionList_Item_ManagerCustomUI_Send2";
import AdmissionList_Item_ManagerCustomUI_SendAM from "../AdmissionsList/Item/ManagerCustomUi/AdmissionList_Item_ManagerCustomUI_SendAM";
import AdmissionList_Item_ManagerCustomUI_AdmissionStatus from "../AdmissionsList/Item/ManagerCustomUi/AdmissionList_Item_ManagerCustomUI_AdmissionStatus";
import AdmissionList_Item_CustomColumn from "../AdmissionsList/Item/AdmissionList_Item_CustomColumn";

const LOCATION = 'LOCATION_TYPE_ADMISSION_LIST';

/**
 * IMP-820 - duplicate the Admissions List ManagerCustomUI columns as blocks on the
 * single admission page. Renders every customUI flagged with `admissionPage_show`,
 * reusing the exact list body components (which emit <td>), wrapped in a minimal
 * table so the markup stays valid outside the list table.
 */
const Admission_ManagerCustomUI = ({admission}) => {
    const managerCustomUI_unified = useSelector(state => state.auth.selectedHospital.managerCustomUI_unified);
    const byPosition = get(managerCustomUI_unified, LOCATION, {});

    // Flatten all positions (already weight-sorted within a position) preserving position order.
    const items = Object.keys(byPosition)
        .sort((a, b) => Number(a) - Number(b))
        .reduce((acc, position) => acc.concat(byPosition[position]), [])
        .filter(customUI => customUI.admissionPage_show);

    if (!items.length) return null;

    const renderBody = (customUI) => {
        switch (customUI.type) {
            case 'TYPE_ADMISSION_LIST_UPLOAD_PDF':
                return <td><AdmissionList_Item_ManagerCustomUI_UploadPdf admission={admission} customUI={customUI}/></td>
            case 'TYPE_ADMISSION_LIST_PRE_ADMISSION_INTEGRATION':
                return <td><AdmissionList_Item_ManagerCustomUI_PreAdmission admission={admission} customUI={customUI}/></td>
            case 'TYPE_ADMISSION_LIST_COMMENTS':
                return <AdmissionList_Item_ManagerCustomUI_Comments admission={admission} customUI={customUI}/>
            case 'TYPE_ADMISSION_LIST_SEND_REG_MED':
            case 'TYPE_ADMISSION_LIST_SEND_REG_MED_MULTIPLE':
                return <AdmissionList_Item_ManagerCustomUI_SendRegMed admission={admission} customUI={customUI}/>
            case 'TYPE_ADMISSION_LIST_COLUMN_SEND':
                return <AdmissionList_Item_CustomColumn admission={admission} managerCustomUi={customUI}/>
            case 'TYPE_ADMISSION_LIST_COLUMN_SEND2':
                return <AdmissionList_Item_ManagerCustomUI_Send2 admission={admission} customUI={customUI} location={LOCATION}/>
            case 'TYPE_ADMISSION_LIST_SEND_AM':
                return <td><AdmissionList_Item_ManagerCustomUI_SendAM admission={admission} customUI={customUI}/></td>
            case 'TYPE_ADMISSION_LIST_ADMISSION_STATUS':
                return <td><AdmissionList_Item_ManagerCustomUI_AdmissionStatus admission={admission} customUI={customUI}/></td>
            default:
                console.error("Unknown CustomUI custom UI type", customUI);
                return null;
        }
    }

    const title = (customUI) => customUI.admissionPage_title || customUI.columnTitle || customUI.header_title || '';

    return (
        <div className="d-flex flex-wrap admission-customUI-row">
            {items.map(customUI => (
                <div className={`admission-customUI-item admission-customUI-item--${customUI.type}`} key={customUI.id}>
                    <div className="admission-customUI-title">{title(customUI)}</div>
                    <div className="admission-customUI-box">
                        <table>
                            <tbody>
                                <tr>{renderBody(customUI)}</tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Admission_ManagerCustomUI;
